module.exports = __webpack_public_path__ + "public/img/userImg.47258174.png";